import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var AverageIncomeTest =
/*#__PURE__*/
function (_BaseData) {
  _inherits(AverageIncomeTest, _BaseData);

  function AverageIncomeTest() {
    _classCallCheck(this, AverageIncomeTest);

    return _possibleConstructorReturn(this, _getPrototypeOf(AverageIncomeTest).call(this, "AverageIncomeTest"));
  }

  _createClass(AverageIncomeTest, [{
    key: "GetRentIncreaseAIT",
    value: function () {
      var _GetRentIncreaseAIT = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(rentRequestHeaderId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetRentIncreaseAIT/").concat(rentRequestHeaderId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetRentIncreaseAIT(_x) {
        return _GetRentIncreaseAIT.apply(this, arguments);
      }

      return GetRentIncreaseAIT;
    }()
  }, {
    key: "SaveRentIncreaseAIT",
    value: function () {
      var _SaveRentIncreaseAIT = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(rentIncreaseAITToSave) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.post("/api/".concat(this._controller, "/SaveRentIncreaseAIT"), rentIncreaseAITToSave));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function SaveRentIncreaseAIT(_x2) {
        return _SaveRentIncreaseAIT.apply(this, arguments);
      }

      return SaveRentIncreaseAIT;
    }()
  }]);

  return AverageIncomeTest;
}(BaseData);

export default new AverageIncomeTest();